exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-list .admin-table td>div{overflow:unset;-webkit-line-clamp:unset}", ""]);

// exports
